import { toBars, betweenReadouts } from "../state/composition.js";
import { CompositionBar } from "./CompositionBar.js";
import type { PaneState } from "../types.js";

interface Props {
  pane: PaneState;
}

/**
 * Right pane — flow-composition bars. Two groups (PUTS then CALLS), each with
 * its at-bid and at-ask bars, plus a per-side between-spread text readout.
 */
export function RightPane({ pane }: Props): JSX.Element {
  const bars = toBars(pane);
  const puts = bars.filter((b) => b.group === "put");
  const calls = bars.filter((b) => b.group === "call");
  const between = betweenReadouts(pane);
  const putBetween = between.find((b) => b.group === "put");
  const callBetween = between.find((b) => b.group === "call");

  return (
    <section className="tape-pane">
      <h2 className="tape-pane__label">Flow Composition (% of day volume, per side)</h2>
      <div className="comp-groups">
        <div className="comp-group">
          <div className="comp-group__bars">
            {puts.map((b) => (
              <CompositionBar key={b.key} bar={b} />
            ))}
          </div>
          <span className="comp-group__name">Puts</span>
          {putBetween ? <span className="comp-between">{putBetween.label}</span> : null}
        </div>
        <div className="comp-group">
          <div className="comp-group__bars">
            {calls.map((b) => (
              <CompositionBar key={b.key} bar={b} />
            ))}
          </div>
          <span className="comp-group__name">Calls</span>
          {callBetween ? <span className="comp-between">{callBetween.label}</span> : null}
        </div>
      </div>
    </section>
  );
}
